import { useState } from "react";
import styles from "./CreateWalletModal.module.css";
import { API_URL } from '../../../config/api';

const CreateWalletModal = ({ onClose, onCreated, wallet }) => {
  const [bankName, setBankName] = useState(wallet?.bank_name || "");
  const [iik, setIik] = useState(wallet?.iik || "");
  const [bik, setBik] = useState(wallet?.bik || "");
  const [kbe, setKbe] = useState(wallet?.kbe || "");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);



  const validate = () => {
    const newErrors = {};
    if (!bankName.trim()) newErrors.bankName = "Обязательное поле";
    if (!iik.trim()) newErrors.iik = "Обязательное поле";
    else if (iik.trim().length < 20) newErrors.iik = "ИИК должен быть минимум 20 символов";
    if (!bik.trim()) newErrors.bik = "Обязательное поле";
    else if (bik.trim().length < 8) newErrors.bik = "БИК должен быть минимум 8 символов";
    if (!kbe.trim()) newErrors.kbe = "Обязательное поле";
    else if (Number(kbe) < 11 || Number(kbe) > 29) newErrors.kbe = "КБЕ должен быть между 11 и 29";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const url = wallet ? `${API_URL}/api/wallets/${wallet.id}` : `${API_URL}/api/wallets`;
      const method = wallet ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          type: "card",
          bank_name: bankName,
          iik,
          bik,
          kbe,
          status: "active",
        }),
      });

      if (!res.ok) throw new Error("Ошибка при сохранении кошелька");

      const json = await res.json();
      onCreated(json.data);
      onClose();
    } catch (err) {
      console.error(err);
      alert("Ошибка при отправке данных");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (setter, field) => (e) => {
    setter(e.target.value);
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContent}>
        <h2 className={styles.headText}>Создать кошелек</h2>
        <div className={styles.field}>
          <label>Банк</label>
          <input placeholder="Введите название банка"
            value={bankName}
            onChange={handleInputChange(setBankName, "bankName")}
          />
          {errors.bankName && <span className={styles.error}>{errors.bankName}</span>}
        </div>
        <div className={styles.field}>
          <label>ИИК</label>
          <input
            placeholder="Введите Индивидуальный Идентификационный Код"
            value={iik}
            onChange={handleInputChange(setIik, "iik")}
            maxLength={20} 
          />
          {errors.iik && <span className={styles.error}>{errors.iik}</span>}
        </div>
        <div className={styles.field}>
          <label>БИК</label>
          <input
            placeholder="Введите Банковский Идентификационный Код"
            value={bik}
            onChange={handleInputChange(setBik, "bik")}
            maxLength={8}
          />
          {errors.bik && <span className={styles.error}>{errors.bik}</span>}
        </div>
        <div className={styles.field}>
            <label>КБЕ</label>
            <input
                type="text"
                value={kbe}
                maxLength={2}
                onChange={(e) => {
                const value = e.target.value;

                if (!/^\d*$/.test(value)) return;

                if (value.length === 2) {
                    const num = Number(value);
                    if (num < 11 || num > 29) return;
                }

                if (value.length === 1 && Number(value) > 2) return;

                setKbe(value);
                setErrors((prev) => ({ ...prev, kbe: "" }));
                }}
                onBlur={() => {
                const num = Number(kbe);
                if (!kbe || num < 11 || num > 29) {
                    setErrors((prev) => ({ ...prev, kbe: "КБЕ должен быть между 11 и 29" }));
                }
                }}
                placeholder="Введите число от 11 до 29"
            />
            {errors.kbe && <span className={styles.error}>{errors.kbe}</span>}
        </div>
        <div className={styles.buttons}>
          <button onClick={onClose} disabled={loading}>Отмена</button>
          <button onClick={handleSubmit} disabled={loading}>
            {loading ? "Сохранение..." : "Сохранить"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateWalletModal;
